module.exports = __webpack_public_path__ + "static/media/26.ca0e9d91.jpg";